import {
  NavigationLogging,
  NucleusFrameworkUnhandledErrorHandler,
} from '@absg/angular-common';
import { NucleusHardwareModule } from '@absg/nim-client-shared';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CancelHttpInterceptor } from 'core.services/cancel-http-interceptor.service';
import { RetryInterceptor } from 'core.services/retry-http-interceptor.service';
import { SharedModule } from 'shared.root/shared.module';

import { AuthenticationComponent } from './authentication/authentication.component';
import { RouterExtensionService } from './shared/services/router-extension.service';

@NgModule({
  declarations: [
    AuthenticationComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NucleusHardwareModule,
  ],
  exports: [
    AuthenticationComponent,
  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CancelHttpInterceptor, multi: true },
        { provide: ErrorHandler, useClass: NucleusFrameworkUnhandledErrorHandler },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: CoreModule,
    private routerExtensionService: RouterExtensionService,
    private navigationLogging: NavigationLogging) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the MainModule only');
    }

    // When app starts, the router extension service should be injected so we can start to recognize the route
    // Next lines are added just to avoid linting error
    this.routerExtensionService.setIsBackButtonClicked(false);

    if (!this.navigationLogging) {
      throw new Error('Navigation logging failed to inject');
    }
  }
}
